'use client';

import { useTranslations } from 'next-intl';
// import { StickingMetrics } from './sticking-metrics';
import { StickingListing } from './sticking-listing';

export function StickingPageContent() {
  const t = useTranslations('sticking');

  return (
    <div className='space-y-6'>
      <h1 className='text-2xl font-bold tracking-tight'>{t('pageTitle')}</h1>

      {/* <StickingMetrics /> */}
      <StickingListing />
    </div>
  );
}
